import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

import _findIndex from 'lodash/findIndex'
import _uniqBy from 'lodash/uniqBy'

import pagedDefault from './constants'
import { insertItemArray } from 'utils/utility'

const initialState = pagedDefault
const notesSlice = createSlice({
  name: '@notes',
  initialState,
  reducers: {
    setNotes: (state, action) => {
      const hasItems = action.payload?.items?.length > 0
      if (hasItems) {
        const index = _findIndex(state.items, { code: action.payload.code })
        if (index > 0) {
          const items = insertItemArray(state.items, index, action.payload)
          return { ...state, items: _uniqBy(items, 'code') }
        }
        const newState = { ...state, ...action.payload }
        return { ...newState }
      }
      return initialState
    },
    extraReducers: (builder) => {
      builder.addCase(PURGE, () => initialState)
    }
  }
})

export const { setNotes } = notesSlice.actions

export default notesSlice.reducer
